module.exports = __webpack_public_path__ + "static/sandbox-video-facace974e9e896f40fa14dcaccebb8c.mp4";